var map = {
	"./404.svg": "4532",
	"./avatar_female.svg": "e4d8",
	"./avatar_male.svg": "a853",
	"./broken.svg": "c7f7",
	"./code.svg": "9ef6",
	"./empty.svg": "5f0d",
	"./forgotpass.svg": "b774",
	"./login.svg": "8692",
	"./merge.svg": "1312",
	"./mobileauth.svg": "c601",
	"./post-add.svg": "73eb",
	"./profile.svg": "2b7f",
	"./signup.svg": "f53e",
	"./success.svg": "1b27",
	"./upload-add.svg": "fc27"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "af8c";